/**
 * CSRF Token Helper Utility
 * Provides simple CSRF token management for authentication requests
 */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.wormser-maxicar.de/api';

/**
 * Get CSRF token from storage or fetch from server
 */
export const getCSRFToken = async () => {
  try {
    // First try to get from sessionStorage
    let csrfToken = sessionStorage.getItem('csrf_token');
    
    if (csrfToken) {
      console.log('✅ Using cached CSRF token');
      return csrfToken;
    }
    
    // If not in storage, fetch from server
    console.log('🔐 Fetching new CSRF token...');
    const response = await axios.get(`${API_BASE_URL}/auth/csrf/`, {
      withCredentials: true,
      timeout: 10000
    });
    
    csrfToken = response.data.csrfToken;
    
    if (csrfToken) {
      // Store in sessionStorage for reuse
      sessionStorage.setItem('csrf_token', csrfToken);
      console.log('✅ CSRF token fetched and cached');
      return csrfToken;
    }
    
    console.warn('⚠️ No CSRF token received from server');
    return null;
    
  } catch (error) {
    console.error('❌ Failed to get CSRF token:', error.message);
    return null;
  }
};

/**
 * Clear cached CSRF token
 */
export const clearCSRFToken = () => {
  sessionStorage.removeItem('csrf_token');
  console.log('🧹 CSRF token cleared from cache');
};

/**
 * Add CSRF token to axios instance
 */
export const addCSRFToken = async (axiosInstance) => {
  const csrfToken = await getCSRFToken();
  
  if (csrfToken) {
    axiosInstance.defaults.headers.common['X-CSRFToken'] = csrfToken;
    console.log('✅ CSRF token added to axios instance');
    return true;
  }
  
  console.warn('⚠️ No CSRF token available to add');
  return false;
};

const csrfHelper = {
  getCSRFToken,
  clearCSRFToken,
  addCSRFToken
};

export default csrfHelper;
